import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
// import { AiOutlinePrinter, AiOutlineFilePdf } from "react-icons/ai";
import { SiHyperledger } from "react-icons/si";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
// import jwtDecode from "jwt-decode";
import { MonthlyWagesReportHeader } from "./GridHeaders/MonthlyWagesReportHeader";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import ExcelExporter from "../../Components/ExcelConverter/ExcelExporter";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { wagesColumns, wagesMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";


export default function MonthlyWagesReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/MonthlyWagesReport', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const netoAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.PagaNeto), 0);
    }, [data]);

    const tatimiNePagaTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TatimiNePaga), 0);
    }, [data]);

    const kontributiPunetoritTot = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.KontributiPunetorit), 0);
    }, [data]);

    const kontributiPunedhenesitTot = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.KontributiPunedhenesit), 0);
    }, [data]);

    const brutoTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.PagatBruto), 0);
    }, [data]);

    const totali = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Gjithsej), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        muaji: item.Muaji,
        trs: (item.Punonjes),
        neto: (item.PagaNeto),
        tax: (item.TatimiNePaga),
        employeecontribut: (item.KontributiPunetorit),
        employerscontribut: (item.KontributiPunedhenesit),
        bruto: (item.PagatBruto),
        total: (item.Gjithsej),
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">

            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i pagave"
            />
            <ElementsParagraph text="Raporti mujor i pagave është raport sintetik që bën grumbullimin e pagave në secilin muaj të vitit fiskal." />

            <hr></hr>
            <ExcelFormat
                data={data}
                fileName={`Raporti mujor i pagave`}
                columns={wagesColumns}
                columnMappings={wagesMappings}
                buttonText="XLSX"
            />
            <DataGridComponent columns={MonthlyWagesReportHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Paga Neto', value: netoAmount },
                    { id: 2, label: 'Tatimi ne Paga', value: tatimiNePagaTotal },
                    { id: 3, label: 'Kontributi Punonjesit', value: kontributiPunetoritTot },
                    { id: 4, label: 'Kontributi Punedhënësit', value: kontributiPunedhenesitTot },
                    { id: 5, label: 'Paga Bruto', value: brutoTotal },
                    { id: 6, label: 'Gjithsej', value: totali },

                ]}
            />
        </div>
    )
}